import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_IMG, PRODUCT_NAME, CHECKOUT_URL } from './constants';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const Unit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="text-center" data-id="element-131">
      <div className="bg-brand-ink text-white text-xl sm:text-2xl font-bold px-3 py-1.5 rounded-lg shadow-inner font-mono" data-id="element-132">
        {String(value).padStart(2, '0')}
      </div>
      <p className="text-[10px] font-bold text-brand-slate mt-1 tracking-wider" data-id="element-133">
        {label}
      </p>
    </div>;
  return <section id="pricing" className="py-8 px-4 bg-brand-cloud border-y border-brand-gold/30 scroll-mt-4" data-id="element-134">
      <div className="max-w-2xl mx-auto" data-id="element-135">
        <div className="text-center mb-4" data-id="element-136">
          <p className="text-sm font-extrabold text-brand-blue uppercase tracking-widest mb-1" data-id="element-137">
            Special Offer — Complete 6-in-1 System
          </p>
          <p className="text-base font-bold text-brand-ink mb-3" data-id="element-138">
            Get instant access today and completely transform the way you plan
            and coach gymnastics.
          </p>
          <div className="inline-block bg-brand-navy text-white px-4 py-1.5 rounded-lg shadow-md mb-4" data-id="element-139">
            <p className="font-bold text-sm sm:text-base tracking-wide font-display" data-id="element-140">
              🤸 {PRODUCT_NAME} — Complete 6-in-1 Planning System
            </p>
          </div>
          <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-141">
            <img src={PRODUCT_IMG} alt="Gymnastics Coach Pro 6-in-1 System" className="w-full max-w-xs mx-auto object-contain drop-shadow-xl mb-4 hover:scale-[1.02] transition-transform duration-300" data-id="element-142" />
          </a>
        </div>

        <div className="bg-white border-4 border-brand-gold rounded-2xl p-4 sm:p-6 text-center relative mb-4 shadow-2xl" data-id="element-143">
          <div className="mb-4" data-id="element-144">
            <p className="text-sm sm:text-base font-bold text-brand-slate mb-1" data-id="element-145">
              Regular Price: <span className="line-through" data-id="element-146">$97</span>
            </p>
            <p className="text-lg sm:text-xl font-extrabold text-brand-blue mb-2 uppercase tracking-wide" data-id="element-147">
              🔥 72% OFF — Limited-Time Launch Offer
            </p>
            <p className="text-5xl sm:text-6xl font-display font-extrabold text-brand-ink mb-1" data-id="element-148">
              $27 USD
            </p>
            <p className="text-xs sm:text-sm font-bold text-brand-slate uppercase tracking-wider" data-id="element-149">
              Today Only • Pay securely in your local currency.
            </p>
          </div>

          <div className="bg-brand-blue/5 border border-brand-blue/20 rounded-xl p-3 mb-5" data-id="element-150">
            <p className="text-sm font-bold text-brand-navy mb-2 uppercase tracking-wide" data-id="element-151">
              🔥 Last Chance! This special price expires when the countdown
              reaches zero.
            </p>
            <div className="flex justify-center items-start gap-3" data-id="element-152">
              <Unit value={timeLeft.hours} label="HOURS" data-id="element-153" />
              <div className="text-xl font-bold text-brand-slate mt-1.5" data-id="element-154">:</div>
              <Unit value={timeLeft.minutes} label="MINUTES" data-id="element-155" />
              <div className="text-xl font-bold text-brand-slate mt-1.5" data-id="element-156">:</div>
              <Unit value={timeLeft.seconds} label="SECONDS" data-id="element-157" />
            </div>
          </div>

          <CTAButton href={CHECKOUT_URL} className="!bg-brand-gold !text-brand-ink border-brand-ink/20 shadow-[0_4px_14px_0_rgba(212,166,42,0.39)] hover:!bg-brand-gold/90" data-id="element-158">
            🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-1 text-sm text-brand-ink font-bold" data-id="element-159">
          <div className="flex items-center gap-1.5" data-id="element-160">
            <StarIcon className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-161" />
            <span data-id="element-162">4.9/5 — Verified Coach Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-line" data-id="element-163">•</span>
          <div className="flex items-center gap-1.5" data-id="element-164">
            <ShieldCheckIcon className="w-4 h-4 text-brand-blue" data-id="element-165" />
            <span data-id="element-166">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}